import { FullScreenHandle } from "react-full-screen";
import { MdCloseFullscreen, MdMusicNote, MdMusicOff, MdOpenInFull, MdVolumeOff, MdVolumeUp } from "react-icons/md";
import "../../GamePage.scss";
import { useGameStore } from "../../stores/gameStore";
import { useEffect } from "react";

interface SettingsProps {
    handle: FullScreenHandle;
}

const Settings = ({ handle }: SettingsProps) => {

    const { isSoundOn, setIsSoundOn } = useGameStore((state: any) => ({
        isSoundOn: state.isSoundOn,
        setIsSoundOn: state.setIsSoundOn,
    }));

    const { isMusicOn, setIsMusicOn } = useGameStore((state: any) => ({
        isMusicOn: state.isMusicOn,
        setIsMusicOn: state.setIsMusicOn,
    }));

    const { isFullscreen, setIsFullscreen } = useGameStore((state: any) => ({
        isFullscreen: state.isFullscreen,
        setIsFullscreen: state.setIsFullscreen,
    }));

    // To show cursor
    useEffect(() => {
        document.exitPointerLock();
    }, []);

    return (
        <div className="settings">
            {isSoundOn ?
                <MdVolumeUp
                    className={"menu-icon"}
                    onClick={() => {
                        setIsSoundOn(false);
                    }}
                /> :
                <MdVolumeOff
                    className={"menu-icon"}
                    onClick={() => setIsSoundOn(true)}
                />
            }
            {isMusicOn ?
                <MdMusicNote
                    className={"menu-icon"}
                    onClick={() => setIsMusicOn(false)}
                /> :
                <MdMusicOff
                    className={"menu-icon"}
                    onClick={() => setIsMusicOn(true)}
                />
            }
            {isFullscreen ?
                <MdOpenInFull
                    className={"menu-icon"}
                    onClick={() => {
                        setIsFullscreen(false);
                        handle.exit();
                    }}
                /> :
                <MdCloseFullscreen
                    className={"menu-icon"}
                    onClick={() => {
                        setIsFullscreen(true);
                        handle.enter();
                    }}
                />
            }
        </div>
    );
};

export default Settings;
